import { useState, useEffect, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Linha do tempo da consulta (criação, alterações e mudanças de status), da mais antiga para a mais recente.
// appointmentId falsy desativa a busca — a modal só passa o id quando está aberta.
export function useAppointmentHistory(appointmentId) {
  const [history, setHistory] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(() => {
    if (!appointmentId) return;
    setLoading(true);
    setError(null);
    quarkusApi
      .get(`/appointments/${appointmentId}/history`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setHistory(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data ?? 'Erro ao buscar o histórico da consulta.');
        console.error('ops! ocorreu um erro' + returnFromApi);
      })
      .finally(() => setLoading(false));
  }, [appointmentId]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return { history, isLoading, error, refetch: fetchHistory };
}
